@if (error) {
  <div class="row justify-center">
    <div class="md:w-2/3 text-center">
      <alert text="" [isShowText]="false" variant="warning">
        Oops, there was an error, please try to
        <a routerLink="/login">login again</a>.
      </alert>
    </div>
  </div>
}
